import { PortableText } from '@portabletext/react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import SectionHeader from '../SectionHeader/SectionHeader';
import { headerWithDescType } from 'src/types';

function HighlightColumns({ image, columns, sectionHeader: { title, tagline, description } }) {
  return (
    <Container fluid as="section" className="py-5">
      <SectionHeader title={title} tagline={tagline} description={description} />

      <Container>
        <Row>
          <Row className="justify-content-center w-100">
            {columns.map((column) => (
              <Col key={column._key} xs={12} lg={4} className="mb-3 mt-6">
                <h4 className="h6">{column.title}</h4>
                <div className="text-muted mt-4">
                  <PortableText value={column.description} />
                </div>
                {column.links.map((link) => (
                  <Link key={link._key} _key={link._key} to={link.url} className="btn-link-primary text-uppercase mt-3">
                    {link.title}
                  </Link>
                ))}
              </Col>
            ))}
            {image && (
              <Col xs={12}>
                <GatsbyImage alt={image?.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} />
              </Col>
            )}
          </Row>
        </Row>
      </Container>
    </Container>
  );
}

HighlightColumns.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.arrayOf(PropTypes.shape({})),
      links: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ).isRequired,
  sectionHeader: headerWithDescType.propTypes,
};

HighlightColumns.defaultProps = {
  sectionHeader: headerWithDescType.defaultProps,
};

export default HighlightColumns;
